import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
import { gzipToBase64 } from '../compression/GZipCompressor';
import LZString from 'lz-string';

const baseUrl = new APISettings().getApiURL();

class proposedRuleApi<ProposedRule> extends BaseAPI {
  // constructor() {}

  public getAllProposedRules: () => Promise<ProposedRule[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/proposedRule`)).data.output;
  };

  public getProposedRuleById: (id: number) => Promise<ProposedRule> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/proposedRule/${id}`)).data.output;
  };

  public getProposedRuleByDraftId: (id: number) => Promise<ProposedRule[]> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/proposedRule/GetByDraftId/${id}`)).data.output;
  };

  public createProposedRule: (propsedRule: any) => Promise<ProposedRule> = async (
    proposedRule: any
  ) => {
    let encodedHtml = await gzipToBase64(proposedRule.proposedRuleHtml);
    let encodedProposedRule = { ...proposedRule, proposedRuleHtml: encodedHtml };
    return (await BaseAPI.axios.post(`${baseUrl}/proposedRule/`, encodedProposedRule)).data.output;
  };

  public updateProposedRule: (propsedRule: any) => Promise<ProposedRule> = async (
    proposedRule: any
  ) => {
    // This encodes the HTML so it doesn't get caught by the firewall   
    let encodedHtml = await gzipToBase64(proposedRule.proposedRuleHtml);
    let encodedProposedRule = { ...proposedRule, proposedRuleHtml: encodedHtml };
    return (await BaseAPI.axios.put(`${baseUrl}/proposedRule/`, encodedProposedRule)).data.output;
  };
}

export const proposedRuleAPI = new proposedRuleApi();
